import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export default function Header({
  className,
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {

  return (
    <div
      className={classNames('bg-white border-b border-slate-200', className)}
      {...props}
    >
      {children}
    </div>
  );
}
